<style lang='stylus'scoped>

header {
  margin-top: 10px;
}

.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: #336db0;

  &::after {
    background: @color;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.km {
  color: #999;
  width: 100%;
  font-size: 14px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  // display: flex;
  // flex-direction: column;
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.block {
  // width: fit-content;
  // margin-left: auto;
  // margin-right: auto;
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>

<template>
  <StopTableDetails
    v-if="showStopTableDetails"
    :dimObj="getNewDimObj1()"
    :provinceName="provinceName"
    :provinceCode="provinceCode"
    @closeDetails="onHideStopTableDetails"
  />
  <TimeTableDetails
    v-else-if="showTimeTableDetails"
    :dimObj="getNewDimObj2()"
    :provinceName="provinceName"
    :provinceCode="provinceCode"
    @closeDetails="onHideTimeTableDetails"
  />
  <div v-else>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1" :tab="type" :moduleName="moduleName" :autoChunkMonth="true" :dateSeparator="''"/>
    <div class="carWrap">
      <div class="header">
        <TitleHeader :titleArr="titleArr" :changeTab="changeTab" :tab="tab"/>
        <!-- <TimeHeader :changeTime="changeTime" monTime="monTime"/> -->
        <div class="righth">
          <!--span class="demonstration">统计月份</span-->
          <!--el-date-picker v-model="monTime" type="month" placeholder="选择月" @change="changeTime" style="width: 150px;"></el-date-picker-->
          <dimension-popover :autoChunkMonth="true" :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true"     ref="objDimensionPopover" />
          <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;margin-left: 15px;" placeholder="请选择燃油类型">
            <el-option
              v-for="(item,index) in fuelTypeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            />
          </el-select>
          <el-button v-show="hideExport" style="margin-left:15px;" @click="exportDate">导出</el-button>
        </div>
      </div>
      <div class="km" v-if="tab === 0">单位：万公里</div>
      <div class="km" v-else>单位：万次</div>
      <main>
        <StopTable :clickRow="clickStopTableRow" :allData="allData" v-if="tab === 0" />
        <TimeTable :clickRow="clickTimeTableRow" :allData="allData" v-else />
      </main>
    </div>
    <div class="bottom-top" v-if="tab === 0">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1.道路里程统计：全国各省车辆在运营省内各类型道路的运营里程汇总。</div>
      <div>2.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>3.下一级页面：点击具体省份，展示该运营省内运营里程TOP100企业。</div>
    </div>
    <div class="bottom-top" v-else>
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1.统计逻辑：统计全国各省车辆在本省各类型道路上的加能站停靠次数。</div>
      <div>2.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>3.下一级页面：点击具体省份，展示车辆在该运营省内各类型道路分品牌加能站停靠次数。</div>
    </div>
  </div>
</template>
<script>
import StopTable from './components/stopTable' // 高速加油站停靠表格
import StopTableDetails from './components/stopTableDetails/index'
import TimeTable from './components/timeTable' // 高速运营时段表格
import TimeTableDetails from './components/timeTableDetails/index'
import TitleHeader from './components/titleHeader' // title表格
import TimeHeader from './components/timeHeader' // 时间选择控件
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import { hideExport } from '@/utils/tools'
import { getFuelTypeList , getFuelTypeCode} from '@/utils/dictionary'
import truncate from "lodash/truncate"
import startsWith from "lodash/startsWith"
import cloneDeep from "lodash/cloneDeep"
import get from "lodash/get"
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
export default {
  components: {
    StopTable,
    TimeTable,
    TitleHeader,
    TimeHeader,
    StopTableDetails,
    TimeTableDetails,
    dimensionPopover,
    dimensionDialog,
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    let monTime = new Date()
    monTime.setMonth(monTime.getMonth() - 1)
    let year = monTime.getFullYear()
    let month = monTime.getMonth()
    let dimObj = {
      year : year+"",
      month : this.initMonth(month)+"",
      type : "0",
    };
    let endMonth = dimObj.year+dimObj.month;
    return {
      provinceName:"",
      provinceCode:"",
      showStopTableDetails:false,
      showTimeTableDetails:false,
      fuelTypeList,
      fuelType:"",
      hideExport:hideExport,
      moduleName: 'wayRoadType',
      titleArr: ['途经各省道路里程统计', '停靠各省道路加油站次数统计'],
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      //monTime,
      showExport: false,
      type: 1, //1-里程  2 加油站
      allData: [], // 总数据
      endMonth, //请求日期
      firstIs: 0, //0 左侧列表  1 日期
      dimObj,
    }
  },
  mounted() {
    /*let that = this
    let time = that.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    that.endMonth = year + that.initMonth(month)*/
    // this.initData()
    this.moren()
  },
  methods: {
         async moren(){
           var that=this
         let year=this.dimObj.year
        let month=this.dimObj.month
         let params={
           year,
           type: this.type
         }
      let {data}=await http.exportFreightDiscern_wayRoadType(params)
      let dataMon=data.reverse()
          for(let it of dataMon){
             if(it.includes('ok')) {
               month=it.substring(0,2)
               that.dimObj.month=month
               that.$refs.objDimensionPopover.setCtrlValue()
             that.initData()
              return
        }
      }
    },



    getNewDimObj1(){
      let obj = cloneDeep(this.dimObj)
      if(obj.type!=="0"){
        obj.type="0"
        obj.month="01"
      }
      return obj;
    },
    getNewDimObj2(){
      return cloneDeep(this.dimObj)
    },
    getProviceName(name){
      if(startsWith(name,'内蒙古')||startsWith(name,'黑龙江')){
          return truncate(name,{"length":3,"omission":""});
      }else{
          return truncate(name,{"length":2,"omission":""});
      }
    },
    onHideStopTableDetails(){
      this.showStopTableDetails=false;
    },
    onHideTimeTableDetails(){
      this.showTimeTableDetails=false;
    },
    clickStopTableRow(rows){
      this.provinceName=this.getProviceName(rows.pathwayProvince);
      this.provinceCode=rows.pathwayProvcode;
      this.showStopTableDetails=true;
    },
    clickTimeTableRow(rows){
      this.provinceName=this.getProviceName(rows.pathwayProvince);
      this.provinceCode=rows.pathwayProvcode;
      this.showTimeTableDetails=true;
    },
    initData() {
      /*let that = this
      that.allData = []
      http
        .carProvinceMileage({
          type: that.type,
          yearMonth: that.endMonth,
          firstIs: that.firstIs
        })
        .then(e => {
          that.allData = [...e.data.tPageUtil.list]
          let time = e.data.time
          that.endMonth = time
          //that.monTime = time.replace(/(.{4})/g, '$1-')
        })*/
      let that = this
      that.allData = []
      let range=that.dimObj.year+that.dimObj.month;//202006,201904,
      let dateType=that.dimObj.type+"";
      let fuelType=getFuelTypeCode(this.fuelType);
      if(that.type===1){
        let param = {
          range,
          dateType,
          fuelType,
        };
        http
          .carProvinceMileageV2_getMiles(param)
          .then(e => {
            that.allData = get(e,"data",[])
            //let time = e.data.time
            //that.endMonth = time
            //that.monTime = time.replace(/(.{4})/g, '$1-')
          })
      }else if(that.type===2){
        let param = {
          range,
          dateType,
          fuelType,
        };
        console.log(param);
        http
          .carProvinceMileageV2_getGasStationStat(param)
          .then(e => {
            console.log(e);
            that.allData = get(e,"data",[])
            //let time = e.data.time
            //that.endMonth = time
            //that.monTime = time.replace(/(.{4})/g, '$1-')
          })
      }
    },
    changeTab(index) {
      let that = this
      that.tab = index
      that.type = index + 1
      this.initData()
    },
    changeFuelType(){
      this.initData()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    changeDimension(e){
      if(e.isOk){
        this.endMonth = e.year+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      let that = this
      /*let time = that.monTime
      let year = time.getFullYear()
      let month = time.getMonth()
      that.endMonth = year + that.initMonth(month)*/
      that.firstIs = 1
      that.initData()
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    exportDate() {
      this.showExport = true
      return
    }
  }
}
</script>
